import * as React from 'react'
import { createFileRoute } from "@tanstack/react-router"
import { DeviceProfileList } from "@/components/sensory"
import { AddDeviceProfileComposer } from "@/forms/sensory"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import { useToast } from "@/contexts/ToastContext"

type View = 'list' | 'create'

export const Route = createFileRoute("/sensory/device-profiles/")({
  staticData: {
    title: 'Device Profiles',
    isSecured: true,
  },
  component: DeviceProfilesPage,
})

function DeviceProfilesPage() {
  const { toast } = useToast()
  const [view, setView] = React.useState<View>('list')
  const [listKey, setListKey] = React.useState(0)

  const handleAdd = () => {
    setView('create')
  }

  const handleBack = () => {
    setView('list')
  }

  const handleCreateSuccess = () => {
    toast({ title: 'Success', description: 'Device profile created successfully.', type: 'success' })
    setListKey((k) => k + 1)
    setView('list')
  }

  const handleError = (error: Error) => {
    toast({ title: 'Error', description: error.message, type: 'error' })
  }

  if (view === 'create') {
    return (
      <div className="p-6 space-y-4">
        <Button variant="ghost" className="gap-2" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4" />
          Back to Device Profiles
        </Button>
        <AddDeviceProfileComposer
          onSuccess={handleCreateSuccess}
          onError={handleError}
          onCancel={handleBack}
        />
      </div>
    )
  }

  return (
    <div className="p-6">
      <DeviceProfileList
        key={listKey}
        onAdd={handleAdd}
      />
    </div>
  )
}
